let PIXI;
if (typeof window !== 'undefined') {
  PIXI = require('pixi.js');
  // TODO: trye this
  // PIXI.glCore.VertexArrayObject.FORCE_NATIVE;
  PIXI.ticker.shared.autoStart = false;
}

import FramedImage from './FramedImage';
import PixiSlider from './PixiSlider';
const testImg = '/img/Homepage_Exhibition.jpg';

class PixiApp {
  onInit = [];
  init(containerEl, width = window.innerWidth, height = window.innerHeight) {
    this.app = new PIXI.Application({
      width: width,
      height: height,
      antialias: false,
      transparent: true,
      resolution: 1,
      autoStart: false,
    });

    // make pixi full screen
    this.app.renderer.view.style.position = 'absolute';
    this.app.renderer.view.style.display = 'block';
    this.app.renderer.autoResize = true;

    // stop shared ticker
    PIXI.ticker.shared.stop();
    this.app.stop();
    this.isStopped = true;
    window.addEventListener('resize', this.updatePixiSize);
    containerEl.appendChild(this.app.view);
    this.slider = new PixiSlider(this.app);
    this.onInit.forEach(func => {
      func();
    });
  }
  sliderTo(index) {
    this.slider.animateToIndex(index);
  }
  populateSlider(slideImgs) {
    // TODO: should check to make sure this can't get pushed to onInit twice
    if (this.slider) {
      this.slider.populateSlideshow(slideImgs);
    } else {
      this.onInit.push(() => {
        this.slider.populateSlideshow(slideImgs);
      });
    }
  }
  skipSliderTo(index) {
    this.slider.skipToIndex(index);
  }
  // skips slider to correct index and hides slide
  startChapterExit(currentChapterIndex) {
    this.slider.startChapterExit(currentChapterIndex);
  }
  exitToChapter(
    type,
    imgSrc,
    drawCallback,
    currentChapterIndex,
    nextIndex,
    panCallback,
    completeCallback,
    startScreenAlpha = 0.4,
    endScreenAlpha = 0,
    focalX = 0.5,
    focalY = 0.5,
    currentSlideIndex
  ) {
    if (this.isStopped) {
      this.showSlider();
      TweenLite.set(this.slider.track, {
        pixi: {
          alpha: 1,
        },
      });
    }
    this.slider.chapterToNextChapter(
      type,
      imgSrc,
      drawCallback,
      currentChapterIndex,
      nextIndex,
      panCallback,
      completeCallback,
      startScreenAlpha,
      endScreenAlpha,
      focalX,
      focalY,
      currentSlideIndex
    );
  }
  openCurrentChapter = onComplete => {
    TweenLite.set(this.slider.track, {
      pixi: {
        alpha: 1,
      },
    });
    this.slider.openCurrentChapter(onComplete);
  };
  updatePixiSize = () => {
    this.app.renderer.resize(window.innerWidth, window.innerHeight);
  };
  sliderStartVisibility(hidden) {
    if (this.slider) {
      if (hidden) {
        this.hideSlider();
      } else {
        this.showSlider();
      }
    } else {
      this.onInit.push(() => {
        if (hidden) {
          this.hideSlider();
        } else {
          this.showSlider();
        }
      });
    }
  }
  fadeOutSlider() {
    TweenLite.to(this.slider.track, 0.6, {
      pixi: {
        alpha: 0,
      },
      ease: Power1.easeInOut,
    });
  }
  fadeOnSlider() {
    this.isStopped = false;
    this.app.start();
    this.slider.handleResize();
    this.app.ticker.update();
    this.slider.contractSlides(false, 0);
    TweenLite.set(this.slider.track, {
      pixi: {
        alpha: 0,
      },
    });
    this.slider.track.visible = true;
    this.slider.expandSlides(1);
    TweenLite.to(this.slider.track, 1, {
      pixi: {
        alpha: 1,
      },
      ease: Power1.easeInOut,
    });
  }
  setSliderVisible() {
    TweenLite.set(this.slider.track, {
      pixi: {
        alpha: 1,
      },
    });
  }
  hideSlider() {
    TweenLite.set(this.slider.track, {
      pixi: {
        alpha: 0,
      },
    });
    this.isStopped = true;
    this.slider.hide();
    // force tick after hide, then stop
    this.app.ticker.update();
    this.app.stop();
  }
  showSlider() {
    this.isStopped = false;
    this.app.start();
    this.slider.show();
  }
  getView() {
    return this.app.view;
  }
}

export let pixiApp = new PixiApp();



// WEBPACK FOOTER //
// ./src/components/pixi/PixiApp.js